import { buildProps, definePropType } from '@zoryn/utils'
import { useEmptyValuesProps, useSizeProp } from '@zoryn/hooks'

import type { ExtractPropTypes, ExtractPublicPropTypes } from 'vue'
import type { Language } from '@zoryn/locale'
import type { ButtonConfigContext } from '@zoryn/components/button'
import type { CardConfigContext } from '@zoryn/components/card'
import type { DialogConfigContext } from '@zoryn/components/dialog'
import type { MessageConfigContext } from '@zoryn/components/message'
import type { LinkConfigContext } from '@zoryn/components/link'
import type { LovConfigContext } from '@zoryn/hooks'
import type { GridConfigContext } from '@zoryn/components/grid'
// import type { TableConfigContext } from '@zoryn/components/data-table'

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export type ExperimentalFeatures = {
  // TO BE Defined
}

export const configProviderProps = buildProps({
  /**
   * @description Controlling if the users want a11y features
   */
  a11y: {
    type: Boolean,
    default: true,
  },
  /**
   * @description Locale Object
   */
  locale: {
    type: definePropType<Language>(Object),
  },
  /**
   * @description global component size
   */
  size: useSizeProp,
  /**
   * @description enable dark theme (adds `dark` class on `html`)
   */
  dark: Boolean,
  /**
   * @description 值集（LOV）全局配置：单元格展示 `GET /system/lov/getLov`、编辑弹窗 `GET /system/lov/getLovList`
   */
  lov: {
    type: definePropType<LovConfigContext>(Object),
  },
  /**
   * @description ZGrid 全局配置：导入入口等
   */
  grid: {
    type: definePropType<GridConfigContext>(Object),
  },
  /**
   * @description button related configuration
   */
  button: {
    type: definePropType<ButtonConfigContext>(Object),
  },
  /**
   * @description card related configuration
   */
  card: {
    type: definePropType<CardConfigContext>(Object),
  },
  /**
   * @description dialog related configuration
   */
  dialog: {
    type: definePropType<DialogConfigContext>(Object),
  },
  /**
   * @description link related configuration
   */
  link: {
    type: definePropType<LinkConfigContext>(Object),
  },
  /**
   * @description features at experimental stage to be added, all features are default to be set to false
   */
  experimentalFeatures: {
    type: definePropType<ExperimentalFeatures>(Object),
  },
  /**
   * @description Controls if we should handle keyboard navigation
   */
  keyboardNavigation: {
    type: Boolean,
    default: true,
  },
  /**
   * @description message related configuration
   */
  message: {
    type: definePropType<MessageConfigContext>(Object),
  },
  /**
   * @description global Initial zIndex
   */
  zIndex: Number,
  /**
   * @description global component className prefix (cooperated with `$namespace` in theme-chalk)
   */
  namespace: {
    type: String,
    default: 'z',
  },
  /**
   * @description table related configuration
   */
  // table: {
  //   type: definePropType<TableConfigContext>(Object),
  // },
  ...useEmptyValuesProps,
} as const)
export type ConfigProviderProps = ExtractPropTypes<typeof configProviderProps>
export type ConfigProviderPropsPublic = ExtractPublicPropTypes<
  typeof configProviderProps
>
